import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** 短剧详情代码加载时对齐原接口加载区，避免先展示完整详情再收缩 */
export function VideoDetailsSkeleton() {
  return (
    <div className="p-6 space-y-6" aria-hidden="true">
      {/** 返回入口和短剧详情标题 */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9" />
          <Skeleton className="h-8 w-24" />
        </div>
      </div>
      <Card>
        <CardContent className="p-6">
          {/** 与原 Loading 的 400px 最小高度及提示位置保持一致 */}
          <div className="flex flex-col items-center justify-center min-h-[400px] w-full gap-2">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-5 w-16" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
